import { useState, useEffect, useCallback } from 'react';

const TUTORIAL_STORAGE_KEY = 'motivator_tutorial_completed';
const DEMO_STORAGE_KEY = 'motivator_demo_completed';

export default function useTutorial() {
  const [showCarousel, setShowCarousel] = useState(false);
  const [showDemo, setShowDemo] = useState(false);
  const [showTour, setShowTour] = useState(false);
  const [tutorialCompleted, setTutorialCompleted] = useState(true);
  const [demoCompleted, setDemoCompleted] = useState(true);
  const [isFirstTime, setIsFirstTime] = useState(false);

  useEffect(() => {
    // Check if tutorial and demo were already completed
    const tutorialDone = localStorage.getItem(TUTORIAL_STORAGE_KEY);
    const demoDone = localStorage.getItem(DEMO_STORAGE_KEY);
    
    if (!tutorialDone) {
      // First time user
      setIsFirstTime(true);
      setTutorialCompleted(false);
      setDemoCompleted(false);
      setShowCarousel(true);
    } else if (!demoDone) {
      // Tutorial done but demo not done (shouldn't happen but handle it)
      setDemoCompleted(false);
    }
  }, []);

  const completeCarousel = useCallback(() => {
    setShowCarousel(false);
    
    if (isFirstTime) {
      // First time: show interactive demo after carousel
      setTimeout(() => {
        setShowDemo(true);
      }, 300);
    } else {
      // Repeat tutorial: show tour after carousel
      setTimeout(() => {
        setShowTour(true);
      }, 500);
    }
  }, [isFirstTime]);

  const completeDemo = useCallback(() => {
    setShowDemo(false);
    setDemoCompleted(true);
    localStorage.setItem(DEMO_STORAGE_KEY, 'true');
    
    // After demo, show the guided tour
    setTimeout(() => {
      setShowTour(true);
    }, 500);
  }, []);

  const completeTour = useCallback(() => {
    setShowTour(false);
    setTutorialCompleted(true);
    localStorage.setItem(TUTORIAL_STORAGE_KEY, 'true');
    setIsFirstTime(false);
  }, []);

  const resetTutorial = useCallback(() => {
    // Reset only tutorial, not demo (demo was already done)
    localStorage.removeItem(TUTORIAL_STORAGE_KEY);
    setTutorialCompleted(false);
    setIsFirstTime(false); // Not first time anymore, skip demo
    setShowCarousel(true);
    setShowDemo(false);
    setShowTour(false);
  }, []);

  const skipAll = useCallback(() => {
    setShowCarousel(false);
    setShowDemo(false);
    setShowTour(false);
    setTutorialCompleted(true);
    setDemoCompleted(true);
    localStorage.setItem(TUTORIAL_STORAGE_KEY, 'true');
    localStorage.setItem(DEMO_STORAGE_KEY, 'true');
    setIsFirstTime(false);
  }, []);

  return {
    showCarousel,
    showDemo,
    showTour,
    tutorialCompleted,
    demoCompleted,
    isFirstTime,
    completeCarousel,
    completeDemo,
    completeTour,
    resetTutorial,
    skipAll
  };
}
